<template>
  <v-card class="order-item-comp">
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 md6 class="pa-3">
          <v-autocomplete
            v-model="orderItem.openbilling_product_id"
            :items="products"
            clearable
            item-text="name"
            item-value="id"
            label="Producto"
            :readonly="readonly"
            :disabled="disabled"
          >
            <template v-if="!disabled" slot="append-outer">
              <v-icon v-if="selectedProductId" @click="editSelectedProduct()">
                edit
              </v-icon>
              <v-icon @click="addNewProduct()">add</v-icon>
              <!--<v-icon>add</v-icon>-->
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 md6 class="pa-3">
          <v-btn v-if="!disabled" class="right" icon @click="removeOrderItem()">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs6 class="pa-3">
          <v-textarea
            ref="description"
            v-model="orderItem.description"
            :rules="[rules.required]"
            label="Descripción"
            required
            :rows="1"
            auto-grow
            :readonly="readonly"
            :disabled="disabled"
          ></v-textarea>
        </v-flex>
        <v-flex xs12 md2 class="pa-3">
          <v-text-field
            ref="quantity"
            :rules="[rules.required]"
            class="pr-2"
            v-model="orderItem.quantity"
            label="Cantidad"
            type="number"
            step="0.1"
            :readonly="readonly"
            :disabled="disabled"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md4 class="pa-3">
          <v-text-field
            ref="tax_base"
            :rules="[rules.number]"
            class="pr-2"
            v-model="orderItem.tax_base"
            label="Precio"
            type="number"
            step=".01"
            append-outer-icon="euro"
            :readonly="readonly"
            :disabled="disabled"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md4 class="pa-3">
          <v-text-field
            ref="discount_amount"
            class="pr-2"
            v-model="orderItem.discount_amount"
            label="Descuento"
            type="number"
            :readonly="readonly"
            :disabled="disabled"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md4 class="pa-3">
          <v-select
            ref="discount_type"
            class="pr-2"
            v-model="orderItem.discount_type"
            :items="discountTypes"
            item-text="text"
            item-value="value"
            label="Tipo dto."
            :readonly="readonly"
            :disabled="disabled"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4 class="pa-3">
          <v-select
            ref="tax"
            class="pr-2"
            v-model="orderItem.tax"
            :items="taxes"
            item-text="text"
            item-value="value"
            label="Impuesto"
            :readonly="readonly"
            :disabled="disabled || selectedType === 'suplido'"
          ></v-select>
        </v-flex>
        <v-flex xs12 class="pa-3">
          <v-textarea
            ref="detail"
            v-model="orderItem.detail"
            label="Detalle de la línea de factura"
            :rows="2"
            auto-grow
            hint="Opcional. Aparece en el PDF debajo de la línea, a todo el ancho. Respeta los saltos de línea y, para poner un texto en negrita, escríbelo entre dobles asteriscos: **texto**"
            persistent-hint
            :readonly="readonly"
            :disabled="disabled"
          ></v-textarea>
        </v-flex>
        <!--<v-flex xs12 md3 class="pa-3">
          <v-select
            ref="irpf"
            class="pr-2"
            v-model="orderItem.irpf"
            :items="irpf"
            item-text="text"
            item-value="value"
            label="IRPF"
            :readonly="true"
            :disabled="disabled"
          ></v-select>
        </v-flex>-->
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-layout align-center justify-end row fill-height>
        <v-flex xs12 md9>
          <v-radio-group
            ref="type"
            :rules="[]"
            v-model="orderItem.type"
            row
            class="pl-4 left"
            :readonly="readonly"
            :disabled="disabled"
          >
            <v-radio label="Gasto corriente" value="corriente"></v-radio>
            <v-radio label="Gasto suplido" value="suplido"></v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field
            :readonly="true"
            :disabled="disabled"
            class="pr-2 total-order-item"
            v-model="totalAmountWithTaxes"
            label="Total"
            append-outer-icon="euro"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-actions>
    <open-billing-product-form
      v-if="showCreateProductModalForm"
      :show-modal="showCreateProductModalForm"
      @click-on-close="closeProductModalForm()"
      @on-saved-product="onSavedProduct($event)"
    ></open-billing-product-form>
    <open-billing-product-form
      v-if="showEditProductModalForm"
      :show-modal="showEditProductModalForm"
      :product-id="selectedProductId"
      @click-on-close="closeProductModalForm()"
      @on-saved-product="onUpdatedProduct($event)"
    ></open-billing-product-form>
  </v-card>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api';
import OpenBillingProductForm from '@/modules/openbilling/components/OpenBillingProductForm.vue';
import { taxes, irpf } from '../helpers/taxHelper';

export default {
  name: 'OpenBillingOrderItemComponent',
  components: {
    'open-billing-product-form': OpenBillingProductForm,
  },
  props: ['index', 'item', 'invoiceId', 'rectifyInvoiceId', 'disabled', 'readonly'],
  data() {
    return {
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        number: value => {
          const pattern = /^-?\d+\.?\d*$/;
          return pattern.test(value) || 'Este campo debe ser numérico.';
        },
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
      showCreateProductModalForm: false,
      showEditProductModalForm: false,
      products: [],
      discountTypes: [{ text: '%', value: 'percentage' }, { text: '€', value: 'money' }],
      orderItem: {
        id: null,
        clavedat: null,
        openbilling_invoice_id: null,
        description: null,
        detail: null,
        quantity: 1,
        tax_base: null,
        discount_amount: 0,
        discount_type: 'percentage',
        tax: '21',
        tax_amount: 0,
        irpf: '0',
        irpf_amount: 0,
        total_amount: 0,
        total_amount_with_taxes: 0,
        openbilling_product_id: null,
        type: 'corriente',
      },
    };
  },
  mounted() {
    // this.loadProducts();

    if (this.invoiceId || this.rectifyInvoiceId) {
      Object.keys(this.orderItem).forEach(f => {
        this.orderItem[f] = this.item[f];
      });
    } else {
      this.orderItem.clavedat = this.clavedat;
      Object.keys(this.orderItem).forEach(f => {
        // Preset item
        this.orderItem[f] = this.item[f];

        // Pre-validate fields
        if (this.$refs[f]) {
          this.$refs[f].validate(true);
        }
      });
    }
  },
  computed: {
    clavedat() {
      return this.$store.state.clavedat;
    },
    taxes() {
      return taxes;
    },
    irpf() {
      return irpf;
    },
    description() {
      return this.orderItem.description;
    },
    detail() {
      return this.orderItem.detail;
    },
    quantity() {
      return this.orderItem.quantity;
    },
    taxBase() {
      return this.orderItem.tax_base;
    },
    discountAmount() {
      return this.orderItem.discount_amount;
    },
    selectedDiscountType() {
      return this.orderItem.discount_type;
    },
    selectedTax() {
      return this.orderItem.tax;
    },
    selectedIrpf() {
      return this.orderItem.irpf;
    },
    selectedProductId() {
      return this.orderItem.openbilling_product_id;
    },
    selectedType() {
      return this.orderItem.type;
    },
    totalAmount() {
      let price = this.calculateTotalAmountWithDiscountWithoutTaxes();
      return price.toFixed(2).replace('.', ',');
    },
    totalAmountWithTaxes() {
      let price = this.calculateTotalAmountWithDiscountAndTaxes();
      return price.toFixed(2).replace('.', ',');
    },
    taxAmount() {
      const totalTaxBaseAmount = this.calculateTotalAmountWithDiscountWithoutTaxes();
      return ((this.orderItem.tax * totalTaxBaseAmount) / 100).toFixed(2);
    },
    irpfAmount() {
      const totalTaxBaseAmount = this.calculateTotalAmountWithDiscountWithoutTaxes();
      return ((this.orderItem.irpf * totalTaxBaseAmount) / 100).toFixed(2);
    },
  },
  methods: {
    removeOrderItem() {
      this.$emit('remove-order-item', { index: this.index });
    },
    calculateTotalAmountWithDiscountWithoutTaxes() {
      let price = this.orderItem.quantity * this.orderItem.tax_base;
      if (this.orderItem.discount_amount) {
        let discount =
          this.orderItem.discount_type === 'percentage'
            ? (price * this.orderItem.discount_amount) / 100
            : this.orderItem.discount_amount;
        price = price - discount;
      }
      return price;
    },
    calculateTotalAmountWithDiscountAndTaxes() {
      let price = this.orderItem.quantity * this.orderItem.tax_base;
      if (this.orderItem.discount_amount) {
        let discount =
          this.orderItem.discount_type === 'percentage'
            ? (price * this.orderItem.discount_amount) / 100
            : this.orderItem.discount_amount;
        price = price - discount;
      }
      if (this.selectedType === 'corriente') {
        const taxes = (price * this.selectedTax) / 100;
        const irpf = (price * this.selectedIrpf) / 100;
        price = price + taxes - irpf;
      }
      return price;
    },
    editSelectedProduct() {
      this.showEditProductModalForm = true;
    },
    addNewProduct() {
      this.showCreateProductModalForm = true;
    },
    closeProductModalForm() {
      this.showCreateProductModalForm = false;
      this.showEditProductModalForm = false;
    },
    onSavedProduct(product) {
      this.products.push(product);
      this.orderItem.openbilling_product_id = product.id;
      this.closeProductModalForm();
    },
    onUpdatedProduct(product) {
      this.loadProducts();
      this.orderItem.description = product.name;
      this.orderItem.tax_base = product.price;
      this.orderItem.tax = product.tax;
      this.closeProductModalForm();
    },
    loadProducts() {
      apiCtrl
        .get(`/openbilling/${this.clavedat}/products/list`, {
          params: {
            page: 1,
            per_page: -1,
            sort_by: 'name',
            descending: 'desc',
            clavedat: this.clavedat,
            invoice_type: 'Venta',
          },
        })
        .then(res => {
          this.products = res.data.data;
        });
    },
  },
  watch: {
    description: function() {
      this.$emit('order-item-changed', { index: this.index, orderItem: this.orderItem });
    },
    detail: function() {
      this.$emit('order-item-changed', { index: this.index, orderItem: this.orderItem });
    },
    quantity: function() {
      this.$emit('order-item-changed', { index: this.index, orderItem: this.orderItem });
    },
    taxBase: function() {
      this.$emit('order-item-changed', { index: this.index, orderItem: this.orderItem });
    },
    discountAmount: function() {
      this.$emit('order-item-changed', { index: this.index, orderItem: this.orderItem });
    },
    selectedDiscountType: function() {
      this.$emit('order-item-changed', { index: this.index, orderItem: this.orderItem });
    },
    selectedTax: function() {
      this.$emit('order-item-changed', { index: this.index, orderItem: this.orderItem });
    },
    selectedIrpf: function() {
      this.$emit('order-item-changed', { index: this.index, orderItem: this.orderItem });
    },
    selectedType: function() {
      this.orderItem.tax = '0';
      this.$emit('order-item-changed', { index: this.index, orderItem: this.orderItem });
    },
    selectedProductId: function(id) {
      const product = this.products.find(item => item.id === id);
      if (product) {
        this.orderItem.description = product.name;
        this.orderItem.tax_base = product.price;
        this.orderItem.tax = product.tax;
      }
    },
    totalAmount: function() {
      this.orderItem.total_amount = this.totalAmount.replace(',', '.');
      this.$emit('order-item-changed', { index: this.index, orderItem: this.orderItem });
    },
    totalAmountWithTaxes: function() {
      this.orderItem.tax_amount = this.taxAmount.replace(',', '.');
      this.orderItem.irpf_amount = this.irpfAmount.replace(',', '.');
      this.orderItem.total_amount_with_taxes = this.totalAmountWithTaxes.replace(',', '.');
      this.$emit('order-item-changed', { index: this.index, orderItem: this.orderItem });
    },
  },
};
</script>

<style scoped>
.order-item-comp {
  border: 3px dotted #00afa8;
}
.total-order-item {
  font-size: large;
}
.total-order-item >>> input {
  text-align: right;
}
</style>
